export default __webpack_public_path__ + "static/media/ScoringaPoint.bd2de643.mp3";